import React from 'react';
import Popup from '@components/Popup';
import styles from '../index.module.css';

const ConsentRequiredPopup = ({ visible, onPositiveClick }) => {
  return (
    <Popup
      visible={visible}
      bodyStyle={styles.wrapperTermsOfUsePopup}
      title="利用するには同意が必要です"
      titleClassName={styles.titleConsentRequiredClassName}
      MessagesComponent={<></>}
      customContentStyle={styles.contentTermsOfUseStyle}
      positiveButtonTitle="戻る"
      onPositiveClicked={onPositiveClick}
      positiveButtonClassName={styles.positiveTermsOfUseClass}
      buttonContainerStyle={styles.termsOfUseButtonContainer}
      disableClose
    />
  );
};

export default ConsentRequiredPopup;
